// extracted by mini-css-extract-plugin
export default {"guide":"style_guide__Kc0Ld"};